var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 13.5C3 13.2239 3.22386 13 3.5 13H25.5C25.7761 13 26 13.2239 26 13.5C26 13.7761 25.7761 14 25.5 14H3.5C3.22386 14 3 13.7761 3 13.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 6.5C14 6.22386 14.2239 6 14.5 6H25.5C25.7761 6 26 6.22386 26 6.5C26 6.77614 25.7761 7 25.5 7H14.5C14.2239 7 14 6.77614 14 6.5Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 20.5C3 20.2239 3.22386 20 3.5 20H14.5C14.7761 20 15 20.2239 15 20.5C15 20.7761 14.7761 21 14.5 21H3.5C3.22386 21 3 20.7761 3 20.5Z",
  fill: "currentColor"
})));
export default SvgMenu28;